import { Environment, LogLevel, EnvironmentType } from './environment.interface';

export const environment: Environment = {
  production: true,
  type: EnvironmentType.PRODUCTION,
  apiUrl: 'https://payment-gateway.sokin.com/',
  appName: 'Sokin Pay Checkout App',
  version: '1.0.0',
  debug: false,
  logLevel: LogLevel.ERROR,
  baseRedirectUrl: 'https://sokin.com',
  sardineHost: 'api.eu.sardine.ai',
  sardineClientId: '66e2f6f5-495b-4cb7-85ad-cc12cbdedcb6',
  allowedFrameAncestors: ['pay.sokin.com'],
  apiMaxRetryAttempts: 3,
  apiBaseDelayMs: 1000,
  sentry: {
    dsn: 'https://879c0a4da2669e8f6627338a92129f3d@o4508952820908032.ingest.de.sentry.io/4510126041792592',
    environment: 'prod',
    enabled: true,
  },
  featureFlagConfig: {
    url: 'https://flags.sokin.com',
    key: 'phc_lDSQrIiTO1ZlT3blOT0b6p5wM5JdlLppSWIAz8Z1jYu',
  },
  featureFlags: {
    PaymentLinkLiteHideMarketingBanner: 'PAYMENT_LINK_LITE_HIDE_MARKETING_BANNER',
    PayByBankEnabled: 'PAY_BY_BANK_ENABLED',
  },
  sdkConfig: {
    angularAppBaseUrl: 'https://pay.sokin.com',
    b2bAPIBaseUrl: 'https://payment-gateway.sokin.com',
    b2bAPIBaseUrlDotCom: 'https://payment-gateway.sokin.com',
    allowedOrigins: [
      'https://pay.sokin.com',
      'https://payment-gateway.sokin.com',
      'https://api.sokin.com',
    ],
  },
};
